import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    //Not allowing regisration without token
    {
      path: '/invite',
      redirect: '/',
    },
    {
      path: '/invite/:token',
      name: 'invite',
      component: () => import('@/elements/PreLogin/HandleInviteCard.vue'), //not even used in router/AuthWrapper skips usual routing
      meta: {
        title: 'Invite',
        isPreLogin: true,
      },
    },
    // {
    //   path: '/resetPassword',
    //   name: 'resetPassword',
    //   component: () => import('@/elements/PreLogin/ResetPassword.vue'), //not even used in router/AuthWrapper skips usual routing
    //   meta: {
    //     title: 'Reset Password',
    //     isPreLogin: true,
    //   },
    // },
    {
      //TODO - make it work only for distributors and better
      path: '/',
      name: 'landing',
      component: () => import('@/pages/LandingPage.vue'),
      meta: {
        title: 'Loading',
      },
    },
    {
      //TODO - make it work only for distributors and better
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/pages/DashboardPage.vue'),
      meta: {
        title: 'Dashboard',
      },
    },
    {
      path: '/clientView/:id?',
      name: 'clientDashboard',
      component: () => import('@/pages/DashboardClientPage.vue'),
      meta: {
        title: 'Dashboard',
      },
      props: true,
    },
    {
      path: '/network/:id?',
      name: 'networkDashboard',
      component: () => import('@/pages/DashboardNetworkPage.vue'),
      meta: {
        title: 'Network View',
      },
      props: true,
    },
    {
      path: '/device/:id/:page?',
      name: 'deviceDashboard',
      component: () => import('@/pages/DashboardDevice/DevicePage.vue'),
      meta: {
        title: 'Device',
      },
      props: true,
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: () => import('@/pages/CalendarPage.vue'),
      meta: {
        title: 'Dashboard',
      },
    },
    {
      //TODO - make it work only for distributors and better
      path: '/organizations',
      name: 'organizations',
      component: () => import('@/pages/OrganizationsPage.vue'),
      meta: {
        title: 'Organizations',
      },
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('@/pages/UsersPage.vue'),
      meta: {
        title: 'Users',
      },
    },
    {
      path: '/inviteToMachines',
      name: 'inviteToMachines',
      component: () => import('@/pages/InviteToMachinesPage.vue'),
      meta: {
        title: 'Invites',
      },
    },
    {
      path: '/inviteToOrganization',
      name: 'inviteToOrganization',
      component: () => import('@/pages/InviteToOrganizationPage.vue'),
      meta: {
        title: 'Invite to organization',
      },
    },
    {
      path: '/service',
      name: 'service',
      component: () => import('@/pages/ServicePage.vue'),
      meta: {
        title: 'Dashboard',
      },
    },
    {
      path: '/efficiency',
      name: 'efficiency',
      component: () => import('@/pages/EfficiencyPage.vue'),
      meta: {
        title: 'Dashboard',
      },
    },

    {
      path: '/devices',
      name: 'devices',
      component: () => import('@/pages/DevicesPage.vue'),
      meta: {
        title: 'Devices',
      },
    },

    {
      path: '/userPreferences',
      name: 'userPreferences',
      component: () => import('@/pages/UserPreferencesPage.vue'),
      meta: {
        title: 'User preferences',
      },
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/',
    },
  ],
})

export default router
